(ns minorodata.transform.events
  (:require [minorodata.app.handlers :refer [dispatch reg-event-db
                                             reg-event-fx]]
            [minorodata.app.utils :as app.utils :refer [dispatch-async]]
            [minorodata.transform.model :refer [->unsaved-transform]]
            [re-posh.core :as re-posh]))


(reg-event-fx
 :transform.events/upsert-transform
 (fn [_ [{:keys [group-id transform environment-id upsert-event on-success tab-id]}]]
   (let [{:keys [id ignore-parser command]} transform]
     (cond
       ignore-parser
       {:dispatch [upsert-event {:group-id       group-id
                                 :transform      transform
                                 :environment-id environment-id
                                 :on-success     on-success}]}
       :else
       {:async-flow
        {:first-dispatch
         [:transform.api/parse-sql-v2 {:sql          command
                                       :tab-id       tab-id
                                       :transform-id id}]
         :rules
         [{:when     :seen?
           :events   :transform.api/parse-sql-v2-success-trigger
           :dispatch [upsert-event {:group-id       group-id
                                    :transform      transform
                                    :environment-id environment-id
                                    :on-success     on-success}]
           :halt?    true}

          {:when       :seen-any-of?
           :events     [:transform.api/parse-sql-v2-failure :transform.api/parse-sql-v2-failure-trigger]
           :dispatch-n [[:transforms-panel/update {:transforms-panel/show-parse-error true}]]
           :halt?      true}]}}))))


(reg-event-fx
 :transform.events/extract-deps-and-upsert-transform
 (fn [_ [{:keys [group-id transform upsert-event]}]]
   (let [{:keys [id command]} transform]
     {:async-flow
      {:first-dispatch
       [:transform.api/extract-deps {:sql          command
                                     :transform-id id}]
       :rules
       [{:when     :seen?
         :events   :transform.api/extract-deps-complete
         :dispatch [upsert-event {:group-id  group-id
                                  :transform transform}]
         :halt?    true}]}})))


(reg-event-fx
 :transform.events/cleanup
 (fn [_ [master-id]]
   (let [versions               @(re-posh/subscribe [:transform.subs/transform-versions-by-master-id master-id])
         versions-delete-events (mapv (fn [version-eid] [:transform-version/delete version-eid])
                                      versions)]
     {:dispatch-n (conj versions-delete-events [:transform-versions-list/delete])})))


(reg-event-fx
 :transform.events/add-transform-to-panel
 (fn [_ [transform-id]]
   (let [{:transforms-panel/keys [latest-order-index]} @(re-posh/subscribe [:transforms-panel/pull])
         transform-idx (or latest-order-index 0)
         transform     {:transform/id    transform-id
                        :transform/order transform-idx}]
     {:dispatch-n [[:transform/update [:transform/id transform-id] transform]
                   [:transforms-panel/update {:transforms-panel/transforms         transform
                                              :transforms-panel/latest-order-index (inc transform-idx)}]]})))


(reg-event-fx
 :transform.events/update-diff-screen
 (fn [_ [group-id previous]]
   (let [previous-version @(re-posh/subscribe [:transform/pull [:transform/id previous]])]
     (if (some? previous-version)
       {:dispatch [:transform-versions-list/update {:transform-versions-list/selected previous}]}

       {:async-flow
        {:first-dispatch
         [:transform.api/fetch-single-transform
          {:group-id      group-id
           :transform-id  previous
           :add-to-panel? false}]
         :rules
         [{:when     :seen?
           :events   :transform.api/fetch-single-transform-complete
           :dispatch [:transform-versions-list/update {:transform-versions-list/selected previous}]
           :halt?    true}]}}))))


(def request-transform-keys
  [:id :command :name :description :ignore-parser
   :input-tables :output-tables :is-full :is-temp
   :tags :status :schedule-spec])


(reg-event-fx
 :transform.events/rollback-transform
 (fn [_ [transform-id selected-version-id on-rollback-ev]]
   (let [{:transform/keys [group-id]} @(re-posh/subscribe [:transform/pull [:transform/id transform-id]])
         previous-transform @(re-posh/subscribe [:transform/pull [:transform/id selected-version-id] '[* {:transform/tags [:transform-tag/value]}]])
         new-transform      (-> previous-transform
                                app.utils/drop-ns-in-keys
                                (assoc :id transform-id
                                       :status :active
                                       :group-id group-id)
                                (update :tags #(mapv :value %))
                                (select-keys request-transform-keys))
         unsaved-transform  (->unsaved-transform new-transform)]
     {:dispatch-n [[:unsaved-transform/add unsaved-transform]
                   [:transform.api/update-transform {:group-id  group-id
                                                     :transform new-transform
                                                     :redirect? false}]
                   on-rollback-ev]})))


(reg-event-fx
 :transform.events/save-and-start-by-id
 (fn [_ [launch-params]]
   {:async-flow
    {:id :save-and-start-by-id
     :rules

     ;; Probably need to track when other state changes happen to cancel the
     ;; flow as soon as it's not needed or doesn't make sence anymore

     [{:when     :seen?
       :events   :transform.api/update-transform-failure
       :dispatch [:app.events/add-snack :warning "Please save the transform before launching it."]
       :halt?    true}

      {:when     :seen?
       :events   :transform.api/update-transform-success
       :dispatch-fn (fn [[_ _ _ resp]]
                      (let [new-transform-id      (get-in resp [:data :id])
                            updated-launch-params (assoc launch-params
                                                         :transform-id new-transform-id)]
                        [[:transform.api/start-by-id updated-launch-params]]))
       :halt?    true}]}}))


(reg-event-db
 :transform.events/save-transform-production-preview
 (fn [db [master-id transform]]
   (assoc-in db [:transform/preview-versions master-id] transform)))


(reg-event-fx
 :transform.events/toggle-version-select-modal
 (fn [{:keys [db]} [open? transform {:keys [on-rollback-ev]}]]
   (if open?
     {:db (assoc db :transform.modals/version-history {:open? true :transform transform :on-rollback-ev on-rollback-ev})}
     {:db (assoc db :transform.modals/version-history {:open? false})})))

(reg-event-fx
 :transform.events/refresh-panel
 (fn []
   (let [panel @(re-posh/subscribe [:groups-panel/pull '[{:groups-panel/active-group [:group/id]}]])
         group-id (get-in panel [:groups-panel/active-group :group/id])]
     {:dispatch-n [[:environments.api/fetch-groups]
                   [:environments.api/fetch-transforms {:group-id group-id :replace? true}]
                   [:connections.api/fetch-transform-statuses]]})))

(reg-event-db
 :transform.events/toggle-circular-dependency-modal
 (fn [db [open? transform]]
   (assoc db :transform.modals/revert-circular-deps
          (if open?
            {:open? open? :transform transform}
            {:open? false}))))

(reg-event-fx
 :transform.events/rollback-to-latest-version
 (fn [_ [transform-id master-id]]
   (let [versions @(re-posh/subscribe [:transform.subs/transform-versions master-id])]
     {:dispatch-n [[:transform.events/rollback-transform transform-id (:transform-id (first versions))]
                   [:transform.events/cleanup]
                   [:transform.events/toggle-circular-dependency-modal false]]})))

(reg-event-fx
 :transform.events/fetch-previous-version
 (fn [_ [_transform-id master-id group-id]]
   (let [versions @(re-posh/subscribe [:transform.subs/transform-versions master-id])]
     (when (not-empty versions)
       {:dispatch [:transform.api/fetch-single-transform
                   {:group-id      group-id
                    :transform-id  (:transform-id (first versions))
                    :add-to-panel? false}]}))))

(reg-event-fx
 :transform.events/revert-to-previous-version
 (fn [_ [transform-id master-id group-id]]
   {:dispatch [:transform-versions-list/add
               {:transform-versions-list/current        master-id
                :transform-versions-list/page           1
                :transform-versions-list/items-per-page 2}]
    :async-flow
    {:first-dispatch [:transform.api/fetch-transform-versions master-id]
     :rules [{:when     :seen?
              :events   :transform.api/fetch-transform-versions-complete
              :dispatch [:transform.events/fetch-previous-version transform-id master-id group-id]}
             {:when     :seen?
              :events   :transform.api/fetch-single-transform-complete
              :dispatch [:transform.events/rollback-to-latest-version transform-id master-id]
              :halt?    true}]}}))

(reg-event-fx
 :transform.events/bulk-delete
 (fn [_ [{:keys [transform-ids group-id on-success]}]]
   (let [delete-transform #(dispatch-async [:environments.api/delete-transform
                                            {:group-id     group-id
                                             :transform-id %
                                             :navigate?    false
                                             :silent?      true}])]
     (-> js/Promise
         (.allSettled (map delete-transform transform-ids))
         (.then (fn []
                  (on-success)
                  (dispatch [:app.events/add-snack :success "Transforms deleted"])))
         (.catch (fn [e]
                   (js/console.error "Error deleting transforms" e))))
     nil)))

(reg-event-fx
 :transform.events/bulk-move
 (fn [_ [{:keys [transform-ids group-id on-success]}]]
   (let [move #(dispatch-async [:transform.api/move-to-group
                                {:to-group     group-id
                                 :transform-id %
                                 :silent?      true
                                 :redirect?    false}])]
     (-> js/Promise
         (.allSettled (map move transform-ids))
         (.then (fn []
                  (on-success)
                  (dispatch [:app.events/add-snack :success "Transforms moved"])))
         (.catch #(js/console.error "Error deleting transforms" %)))
     nil)))
